import type { Tenant } from '@sirius/contracts/admin'
import { ExternalLink } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { Badge } from '~/components/ui/badge'
import { Button } from '~/components/ui/button'
import { useBaseDomain } from '~/tenancy/activeTenant'
import { tenantOrigin } from '~/tenancy/tenantHost'

const STATUS_BADGE = {
  active: 'default',
  suspended: 'secondary',
} as const satisfies Record<Tenant['status'], string>

export function TenantStatusBadge({ status }: { status: Tenant['status'] }) {
  const { t } = useTranslation()
  return (
    <Badge variant={STATUS_BADGE[status]}>
      {t(`tenantsPage.common.statusValue.${status}`)}
    </Badge>
  )
}

/** Goes to the tenant's own host (`<slug>.<admin domain>`). */
export function OpenTenantButton({
  tenant,
  kind,
  size,
}: {
  tenant: Pick<Tenant, 'name' | 'slug'>
  /** `open`: the list's short button; `openTenant`: the show page's */
  kind: 'open' | 'openTenant'
  size?: 'sm'
}) {
  const { t } = useTranslation()
  const baseDomain = useBaseDomain()
  return (
    <Button
      variant="outline"
      size={size}
      aria-label={t(
        kind === 'open'
          ? 'tenantsPage.parts.openAria'
          : 'tenantsPage.parts.openTenantAria',
        { name: tenant.name },
      )}
      onClick={() => {
        window.location.assign(
          tenantOrigin(tenant.slug, baseDomain, window.location),
        )
      }}
    >
      <ExternalLink />
      {kind === 'open'
        ? t('tenantsPage.list.open')
        : t('tenantsPage.show.openTenant')}
    </Button>
  )
}
